"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalConfigs = exports.getGlobalConfig = exports.initSecretsCache = void 0;
var secrets = __importStar(require("@aws-sdk/client-secrets-manager"));
var json_1 = require("./json");
var secretsCache;
/**
 * Calls AWS SecretsManager to retrieve the given secret,
 * caching the value globally in-memory if the cache has been initialized.
 * @param secretId
 * @returns
 */
function _getSecretManagerSecrets(secretId) {
    return __awaiter(this, void 0, void 0, function () {
        var client, secret, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (secretsCache && secretsCache[secretId])
                        return [2 /*return*/, secretsCache[secretId]];
                    client = new secrets.SecretsManagerClient({});
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    _a = json_1.safeParse;
                    return [4 /*yield*/, client.send(new secrets.GetSecretValueCommand({
                            SecretId: secretId
                        }))];
                case 2:
                    secret = _a.apply(void 0, [(_b.sent()).SecretString]);
                    if (secretsCache)
                        secretsCache[secretId] = secret;
                    return [2 /*return*/, secret];
                case 3:
                    client.destroy();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Initializes the global in-memory secrets cache for use if it does not exist
 * or clears its contents if it has already been initialized.
 */
function initSecretsCache() { secretsCache = {}; }
exports.initSecretsCache = initSecretsCache;
;
function getGlobalConfig(key) {
    return __awaiter(this, void 0, void 0, function () {
        var secrets_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (process.env[key] && (process.env.NODE_ENV === 'development' || ['ENCRYPTION_KEY', 'HASH_KEY'].indexOf(key) === -1)) {
                        return [2 /*return*/, process.env[key]];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, _getSecretManagerSecrets('LambdaKeys')];
                case 2:
                    secrets_1 = _a.sent();
                    return [2 /*return*/, secrets_1[key]];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, undefined];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getGlobalConfig = getGlobalConfig;
function getGlobalConfigs() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        var result, needToFetch, keys_1, keys_1_1, key, secretJson, k, e_2;
        var e_3, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    result = {};
                    needToFetch = [];
                    try {
                        for (keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                            key = keys_1_1.value;
                            if (process.env[key]) {
                                result[key] = process.env[key];
                                continue;
                            }
                            needToFetch.push(key);
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    if (!needToFetch.length) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, _getSecretManagerSecrets('LambdaKeys')];
                case 2:
                    secretJson = _b.sent();
                    for (k in secretJson) {
                        if (!result[k]) {
                            result[k] = secretJson[k];
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _b.sent();
                    Object.assign(result, __assign(__assign({}, result), needToFetch.reduce(function (acc, key) {
                        if (!result[key]) {
                            acc[key] = undefined;
                        }
                        return acc;
                    }, {})));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, result];
            }
        });
    });
}
exports.getGlobalConfigs = getGlobalConfigs;
